import { render, staticRenderFns } from "./RelatResumoMediasVendedor.vue?vue&type=template&id=689a16a8&"
import script from "./RelatResumoMediasVendedor.vue?vue&type=script&lang=js&"
export * from "./RelatResumoMediasVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports